// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__37MWS","messages":"Chat_messages__2BYqG","dateDivider":"Chat_dateDivider__mu2Ye"};